import React from "react";
import LinkedProgrammeFilters from "./LinkedProgrammeFilters";
import LinkedProgrammeExport from "./LinkedProgrammeExport";
import { StyledResetButton } from "../../../library/BulkToolbarButtons";

/**
 * Toolbar above the linked programmes table: search, filters, reset, and
 * export — all driven by the `hook` returned from the linked-programmes
 * list hook. Built on the same global search-filter-div / dataTables_filter /
 * filter-scroll-inner markup every other table in the codebase (e.g. Career
 * Library) uses, so this one looks and behaves the same way.
 * @param {Object} hook State and handlers from the linked-programmes list hook.
 * @param {number|string} id The programme id, used to scope exports.
 * @param {Object} detail Programme detail (e.g. netsuite_product), used by export.
 */
function LinkedProgrammesToolbar({
    hook,
    id,
    detail,
}) {
    return (
        <div className="search-filter-div">
            <div className="search-filter-div-left">
                <div className="system-administration-table table-responsive">
                    <div className="table-responsive-div">
                        <div className="dataTables_wrapper no-footer">
                            <div className="dataTables_filter">
                                <label>
                                    <i
                                        className="fal fa-search"
                                        aria-hidden="true"
                                    />

                                    <input
                                        type="search"
                                        value={hook.search}
                                        placeholder="Search"
                                        disabled={hook.isProcessing}
                                        aria-label="Search linked programmes"
                                        onChange={(event) => {
                                            hook.setSearch(event.target.value);
                                            hook.setPage(1);
                                        }}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="filter-button-group">
                        <div className="filter-scroll">
                            <div className="filter-scroll-inner filter-custom-new">
                                <LinkedProgrammeFilters
                                    intake={hook.intake}
                                    setIntake={hook.setIntake}
                                    campus={hook.campus}
                                    setCampus={hook.setCampus}
                                    delivery={hook.delivery}
                                    setDelivery={hook.setDelivery}
                                    gradesLocked={hook.gradesLocked}
                                    setGradesLocked={hook.setGradesLocked}
                                    version={hook.version}
                                    setVersion={hook.setVersion}
                                    dropdown={hook.dropdown}
                                    isProcessing={hook.isProcessing}
                                    isVersionEnabled={hook.isVersionEnabled}
                                    setPage={hook.setPage}
                                />
                            </div>
                        </div>

                        <div className="reset-btn-group">
                            <div className="button-reset dropdown-comman">
                                <StyledResetButton
                                    type="button"
                                    onClick={hook.resetFilters}
                                    disabled={hook.isProcessing}
                                >
                                    <i
                                        className="fal fa-redo"
                                        aria-hidden="true"
                                    />

                                    Reset
                                </StyledResetButton>
                            </div>

                            <LinkedProgrammeExport
                                id={id}
                                detail={detail}
                                QAview={hook.QAview}
                                isVersionEnabled={hook.isVersionEnabled}
                                isProcessing={hook.isProcessing}
                                totalRows={hook.totalRows}
                                perPage={hook.perPage}
                                sortKey={hook.sortKey}
                                sortOrder={hook.sortOrder}
                                search={hook.search}
                                campus={hook.campus}
                                intake={hook.intake}
                                delivery={hook.delivery}
                                gradesLocked={hook.gradesLocked}
                                version={hook.version}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LinkedProgrammesToolbar;
